'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _modals = require('redux/modules/modals');

var _modals2 = require('constants/modals');

var _reactRedux = require('react-redux');

var _components = require('components');

var _GenericSettings = require('redux/modules/GenericSettings');

var _QuotesStorage = require('./QuotesStorage.scss');

var _QuotesStorage2 = _interopRequireDefault(_QuotesStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuotesStorage = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(QuotesStorage, _Component);

  function QuotesStorage(props) {
    (0, _classCallCheck3.default)(this, QuotesStorage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (QuotesStorage.__proto__ || (0, _getPrototypeOf2.default)(QuotesStorage)).call(this, props));

    _this._onInputChange = function (event) {
      if (_this.props.changeStorageOptionProperty) {
        _this.props.changeStorageOptionProperty(event.target.name, event.target.value);
      }
    };

    _this._onCheckBoxChange = function (event) {
      var _event$target = event.target,
          name = _event$target.name,
          checked = _event$target.checked;

      var confirmMessage = 'ARE YOU SURE YOU WANT TO ENABLE THE AUTOMATIC DELETION OF QUOTES FROM DATABASE?';

      if (event.target.checked) {
        _this.props.showModal(_modals2.CONFIRM, {
          body: confirmMessage,
          onCancel: function onCancel() {
            return _this.props.hideModal(_modals2.CONFIRM);
          },
          onConfirm: function onConfirm() {
            _this.props.hideModal(_modals2.CONFIRM);
            _this.props.changeStorageOptionProperty(name, checked);
          }
        });
      } else {
        _this.props.changeStorageOptionProperty(name, checked);
      }
    };

    _this.handleExpireDaysChange = _this.handleExpireDaysChange.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(QuotesStorage, [{
    key: 'handleExpireDaysChange',
    value: function handleExpireDaysChange(e) {
      var changeStorageOptionProperty = this.props.changeStorageOptionProperty;

      var value = Number(e.target.value);

      if (value < 1) {
        changeStorageOptionProperty(e.target.name, 1);
      } else if (value > 30) {
        changeStorageOptionProperty(e.target.name, 30);
      } else {
        changeStorageOptionProperty(e.target.name, e.target.value);
      }
    }
  }, {
    key: '_renderAutoQuoteDeletion',
    value: function _renderAutoQuoteDeletion() {
      var configuration = this.props.configuration;


      return (configuration && configuration.autoQuoteDeletionEnabled || null) && _react2.default.createElement(
        _components.EnterpriseGrid.Col,
        { xs: 12 },
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)(_QuotesStorage2.default.autoQuoteDeletion, _QuotesStorage2.default.inputGroup) },
          _react2.default.createElement(
            'label',
            { htmlFor: 'daysSinceQuote' },
            'DAYS SINCE QUOTE HAS BEEN CREATED'
          ),
          _react2.default.createElement(_components.EnterpriseInput, {
            id: 'daysSinceQuote',
            name: 'numberOfDaysQuoteToExpire',
            type: 'number',
            max: '30',
            size: _components.ENTERPRISE_INPUT_SIZES.MEDIUM,
            value: configuration.numberOfDaysQuoteToExpire,
            onChange: this.handleExpireDaysChange
          })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          configuration = _props.configuration,
          templatesList = _props.templatesList;


      var autoQuoteDeletion = this._renderAutoQuoteDeletion(_QuotesStorage2.default);
      var deletionDisabled = false;

      return _react2.default.createElement(
        _components.EnterpriseGrid.Row,
        { className: (0, _classnames2.default)(className, _QuotesStorage2.default.root) },
        _react2.default.createElement(
          _components.EnterpriseGrid.Col,
          { xs: 12 },
          _react2.default.createElement(
            'div',
            { className: _QuotesStorage2.default.header },
            _react2.default.createElement(
              'div',
              { className: _QuotesStorage2.default.headerText },
              'QUOTES STORAGE'
            )
          )
        ),
        _react2.default.createElement(
          _components.EnterpriseGrid.Col,
          { xs: 12 },
          _react2.default.createElement(
            _components.EnterpriseGrid.Row,
            { className: _QuotesStorage2.default.body },
            _react2.default.createElement(
              _components.EnterpriseGrid.Col,
              { xs: 12, className: (0, _classnames2.default)(_QuotesStorage2.default.storageOption, _QuotesStorage2.default.inputGroup) },
              _react2.default.createElement(
                'label',
                { htmlFor: 'DataToStore' },
                'DATA TO STORE'
              ),
              _react2.default.createElement(_components.EnterpriseDropDown, {
                name: 'storageOptionId',
                options: configuration.storageOptions,
                value: configuration && configuration.storageOptionId || undefined,
                onChange: this._onInputChange
              })
            ),
            _react2.default.createElement(
              _components.EnterpriseGrid.Col,
              { xs: 12, className: _QuotesStorage2.default.autoQuoteDeletionEnabler },
              _react2.default.createElement(
                _components.EnterpriseGrid.Row,
                null,
                _react2.default.createElement(
                  _components.EnterpriseGrid.Col,
                  { xs: 12 },
                  _react2.default.createElement(_components.EnterpriseCheckBox, {
                    id: 'autoQuoteDeletionEnabled',
                    name: 'autoQuoteDeletionEnabled',
                    label: 'ENABLE AUTOMATIC QUOTE DELETION' + (configuration && configuration.autoQuoteDeletionEnabled ? ' ▼' : ''),
                    checked: configuration && configuration.autoQuoteDeletionEnabled || false,
                    onChange: this._onCheckBoxChange,
                    disabled: deletionDisabled
                  })
                ),
                autoQuoteDeletion
              )
            )
          )
        )
      );
    }
  }]);
  return QuotesStorage;
}(_react.Component), _class.preload = function () {
  return [[_GenericSettings.fetchGenericSettingsSaga, _GenericSettings.getGenericSettings.base()]];
}, _class.propTypes = {
  configuration: _react.PropTypes.object,
  templatesList: _react.PropTypes.object,
  getGenericSettings: _react.PropTypes.func,
  changeStorageOptionProperty: _react.PropTypes.func,
  showModal: _react.PropTypes.func,
  hideModal: _react.PropTypes.func,
  className: _react.PropTypes.string
}, _temp);


var mapStateToProps = function mapStateToProps(state) {
  return {
    configuration: state.genericSettings.configuration,
    templatesList: state.templateApplication.templates.templates
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  getGenericSettings: _GenericSettings.getGenericSettings.base,
  changeStorageOptionProperty: _GenericSettings.changeStorageOptionProperty,
  showModal: _modals.show,
  hideModal: _modals.hide
})(QuotesStorage);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/QuotesStorate/QuotesStorage.jsx
// module id = 1458
// module chunks = 0